import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectPrizeWallBackgroundImage } from '../../state/prizeWall/prizeWall.slice';
import { PrizeWallBackgroundProps } from './PrizeWallBackground.types';
import PrizeWallImage from '../common/PrizeWallImage/PrizeWallImage';

function PrizeWallBackground({
  contentFit = 'cover',
}: PrizeWallBackgroundProps) {
  const backgroundImage = useSelector(selectPrizeWallBackgroundImage);

  return (
    <PrizeWallImage
      {...backgroundImage}
      contentFit={contentFit}
      position="absolute"
      inset={0}
    />
  );
}

export default memo(PrizeWallBackground);
